// import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
// import { config } from "../config";

// // Define a service using a base URL and expected endpoints
// export const tagApi = createApi({
//   reducerPath: "tagApi",
//   baseQuery: fetchBaseQuery({
//     baseUrl: config.base_url,
//     prepareHeaders: (headers, { getState }) => {
//       const token = localStorage.getItem("token");
//       headers.set("Access-Control-Allow-Origin", "*");
//       headers.set("Authorization", "Bearer " + token);
//       return headers;
//     },
//   }),
//   endpoints: (builder) => ({
//     addTag: builder.mutation({
//       query: (userData) => {
//         return {
//           url: "/add-tag",
//           method: "post",
//           body: userData,
//         };
//       },
//     }),
//   }),
// });

// // Export hooks for usage in functional components, which are
// // auto-generated based on the defined endpoints
// export const { useAddTagMutation } = tagApi;

import { postApi } from "./postAPI";
import { trailApi } from "./trailAPI";
export const tagApi = postApi.injectEndpoints({
  endpoints: (build) => ({
    addTag: build.mutation({
      query(userData) {
        return {
          url: "/add-tag",
          method: "post",
          body: userData,
        };
      },
    }),
  }),
});

export const tagApiForTrail = trailApi.injectEndpoints({
  endpoints: (build) => ({
    addTagForTrail: build.mutation({
      query(userData) {
        return {
          url: "/trail-add-tag",
          method: "post",
          body: userData,
        };
      },
    }),
  }),
});

export const { useAddTagMutation } = tagApi;
export const { useAddTagForTrailMutation } = tagApiForTrail;
